const attributeControlTypes = Object.freeze({
    select: 1,
    input: 4,
    readOnlyCheckbox: 50,
})

export {
    attributeControlTypes,
}